import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export const MarqueeStrip = () => {
  const { content, lang } = useSite();
  const items = (lang === "zh" ? content.marquee_zh : content.marquee_en) || [];

  return (
    <div className="overflow-x-clip">
      <div data-testid="marquee-strip" className="bg-slate-900 py-5 -rotate-1 scale-[1.02] overflow-hidden">
      <Marquee speed={40} gradient={false} pauseOnHover>
        {items.map((item, i) => (
          <span key={i} className="mx-6 flex items-center gap-6 font-display font-extrabold text-xl sm:text-2xl text-white/90 tracking-tight">
            {item}
            <Asterisk size={22} className="text-orange-500" />
          </span>
        ))}
      </Marquee>
      </div>
    </div>
  );
};
